import styled from 'styled-components';

export const DrawControlWrapper = styled.div`
  position: absolute !important;
  /* Page-aware top offset:
     - Bare /search-property: map starts immediately under the filter
       row; top:20 puts the wrapper visually over the rightmost filter
       buttons (Search Result / More Filters), so we need ~100px to
       clear that band.
     - Internal results page: the map already starts well below the
       filter row (because the listing column header pushes everything
       down), so top:20 is fine and 100px parks Draw too far into the
       map.
     Default keeps the historical 20px behavior for any caller that
     doesn't opt in. A number is px; a string is used as-is (e.g. a calc()
     that follows the measured filter bar height). */
  top: ${({ $topOffset }) =>
    typeof $topOffset === 'string' ? $topOffset : `${$topOffset != null ? $topOffset : 20}px`};
  right: 20px;
  /* Sit above the search-filter bar (.new_outer_filter_new is z-index: 4)
     so the Draw dropdown — and its open-state popover, which inherits
     this stacking context — stays clickable. */
  z-index: 10;
  font-size: 16.5px;
  font-weight: 600px;
  width: 140px;

  .circle-radius-input {
    background-color: #f7f9f2;
    padding: '1px 8px';
    width: inherit;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    margin-top: 5px;

    input {
      width: 100%;
      border: none;
      outline: none;
      background: none;
      border-radius: 8px 0 0 8px;
      text-align: center;
    }

    span {
      border: none;
      border-left: 1px solid #ccc;
      width: 50px;
      text-align: center;
    }
  }
`;

export const customSelectStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#969b89' : '#969b89',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1px 8px',
    margin: '5px 0',
    backgroundColor: '#f7f9f2'
  }),

  placeholder: (provided) => ({
    ...provided,
    color: '#969b89',
    fontSize: '16.5px',
    fontWeight: 600
  }),

  control: (provided) => ({
    ...provided,
    borderRadius: '10px 10px 0px 0px',
    border: '1px solid #ccc',
    boxShadow: 'none',
    backgroundColor: '#fcfcfc'
  }),

  menu: (provided) => ({
    ...provided,
    borderRadius: ' 0px 0px 10px 10px',
    border: '1px solid #ccc',
    boxShadow: 'none',
    backgroundColor: '#f7f9f2',
    marginTop: '-1px'
  })
};
